const YOUYUBE_VIDEOS = [
    {
        Category: 'VIDEO',
        Message: 'Sears Home Warranty',
        MessageType: JSON.stringify({
            "type": "video",
            "videoId": "s18qF19m2PM",
            "value": 'Sears Home Warranty'
        }),
        Id: 'VIDEO1',
        readOnly: true
    },
    {
        Category: 'VIDEO',
        Message: 'Sears Home Warranty 1',
        MessageType: JSON.stringify({
            "type": "video",
            "videoId": "VhuXaAVftxc",
            "value": 'Sears Home Warranty 1'
        }),
        Id: 'VIDEO2',
        readOnly: true
    },
    {
        Category: 'VIDEO',
        Message: 'Sears Home service HI',
        MessageType: JSON.stringify({
            "type": "video",
            "videoId": "KZsyQMSjJGE",
            "value": 'Sears Home service HI'
        }),
        Id: 'VIDEO3',
        readOnly: true
    }
]

const coupon = [
    {
        Category: 'COUPON',
        Message: 'Cancel Coupon',
        MessageType: "https://mso-connect-chat.s3.amazonaws.com/images/Chat_Cancellation+Coupon.jpg",
        Id: 'COUPON1',
        readOnly: true
    }
]

export { YOUYUBE_VIDEOS, coupon }